import { SumRowTDElement } from '../TimeWindowStyles';
import Tooltip from 'components/Tooltip/Tooltip';
import { Warning, Success } from 'components/Icons';

type Props = {
  percentage: number;
};

export const TimeWindowSumRow = ({ percentage }: Props) => {
  const sumIsValid = percentage === 100;
  const SumIcon = sumIsValid ? (
    <Success size='16px' fill='#2E8540' className='mr-2' />
  ) : (
    <Warning size='13px' className='mr-2' fill='#AA0101' />
  );

  return (
    <tr key='sum'>
      <SumRowTDElement align='left' key={1}>
        Weight Total (Must sum to 100%)
      </SumRowTDElement>
      <SumRowTDElement align='center' key={2}>
        <Tooltip
          disabled={sumIsValid}
          message='The total must sum up to 100%.'
          delay={300}
        >
          {SumIcon}
          {percentage}%
        </Tooltip>
      </SumRowTDElement>
      <SumRowTDElement key={3} />
      <SumRowTDElement align='center' key={4}></SumRowTDElement>
    </tr>
  );
};
